import { createAsyncThunk } from '@reduxjs/toolkit';

import type { AuthControllerLogoutResponse } from '~/api';
import { authControllerLogout } from '~/api';
import { getErrorMessage } from '~/utils/api';

export const signOut = createAsyncThunk<AuthControllerLogoutResponse, undefined, { rejectValue: string }>(
  'admin/signOut',
  async (_, { rejectWithValue }) => {
    try {
      const response = await authControllerLogout();

      if (!response.data) {
        return rejectWithValue(getErrorMessage(response));
      }

      return response.data;
    } catch (e) {
      return rejectWithValue((e as Error).message);
    }
  }
);
